// @flow
import React, { useRef, useEffect, useMemo, useState, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Invoice from '../../components/invoice/Invoice';
import useOrder from '../../hooks/orders';
// import Loading from '../../components/loading/Loading';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import QRCode from 'qrcode.react';
import CancelIcon from '@material-ui/icons/Cancel';

import Loading from '../../components/loading/Loading';
import BottomNav from '../bottom-nav/BottomNav';
import TMDrawer from '../tm-drawer/TmDrawer';
import useFirebase from '../../hooks/firebase';
import config from '../../config';
import useRating from '../../hooks/rating';
import usePod from '../../hooks/pods';
import useRealtimeConnection from '../../hooks/useRealtimeConnection';
import RatingDlg from '../../components/rating-dlg/RatingDlg';
import {
	VIRTUAL_ORDER,
	RECEIVED_ORDER,
	ACTIVE_ORDER,
	COMPLETED_ORDER,
	CANCELLED_ORDER,
	MACHINE_ORDER,
	KIOSK_ORDER,
	FAILED_ORDER,
	PARTIAL_ORDER,
} from '../../constants';
import OrderHeader from '../../components/order-header/OrderHeader';
import LoadingProgressIndicator from '../../components/loading-progress-indicator/LoadingProgressIndicator';
import OrderHelpSection from '../../components/order-help-section/OrderHelpSection';

//TM06202507 is Texas machine stuck at 1043...
//NU09202301 is Spiral machine currently in warehouse...
//TM12202299 is Neuu Spiral machine.
const IFRAME_ONLY_MACHINES = [/*"NU09202301", "NU11202501",*/ "TM12202299"/*, "TM06202507"*/];
const SOCKET_ONLY_MACHINES = ["TM09202202", "TM09202301", "TM02202301", "TM09202501", "TM10201907", "TM06202201", "TM06202202", "TM06202203", "TM06202503", "TM07202501", "TM05202204", "TM08202202", "TM04202203", "TM03202201", "TM06202004", "TM03202401", "TM06202305", "TM06202003", "TM06202506", "TM09202502", "TM06202508", "TM06202304"];


const useStyles = makeStyles((theme) => ({
	pageContainer: {
		minHeight: 'inherit',
	},
	backBtn: {
		padding: '0',
	},
	backIcon: {
		fontSize: '24px',
		color: 'white',
		lineHeight: '26px',
		height: '28px',
	},
	mainContainer: {
		minHeight: 'calc(100vh - 60px)',
		border: 'none',
		backgroundColor: '#f6f6f6',
		position: 'relative',
		'&.qrView': {
			height: 'calc(100vh - 60px)',
			overflow: 'hidden',
		},
		marginBottom: 60,
	},
	helpText: {
		fontSize: '14px',
		marginBottom: '6px',
	},
	cancelBtn: {
		color: '#869a12',
		marginBottom: '30px',
		fontWeight: 'bold',
		fontSize: 14,
	},
	supportBtn: {
		borderRadius: '4px',
		backgroundColor: '#bedc13',
		height: '48px',
		width: '250px',
		'&:hover': {
			backgroundColor: '#bedc13',
		},
		marginBottom: '10px',
	},
	invoiceContainer: {
		//flex: 1,
		//minHeight: 'calc(100vh - 250px)',
		display: 'flex',
		height:'500px',
		border: 'none',
		backgroundColor: '#f6f6f6',
		alignItems: 'center',
		overflow:'scroll !important',
		WebkitOverflowScrolling:'touch !important',
		width:'300px',

	},
	buttonProgress: {
		color: '#bedc13',
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -12,
		marginLeft: -12,
	},
	header: {
		position: 'relative',
		color: 'white',
		fontSize: '16px',
		fontWeight: '500',
		display: 'flex',
		alignItems: 'center',
		padding: '14px',
		height: '60px',
		backgroundColor: '#f05b83',
	},
	qrContainer: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '0',
		height: '0',
		display: 'none',
		backgroundColor: '#f2f0f0',
		'&.visible': {
			width: '100%',
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
		},
		'& canvas': {
			alignSelf: 'center',
		},
		'& .MuiIconButton-root': {
			marginBottom: 20,
			'& .MuiSvgIcon-root': {
				fontSize: '2rem',
			},
		},
		'& section:last-child': {
			margin: 20,
			textAlign: 'center',
			fontSize: 16,
			color: '#f05b83',
		},
	},
	circularLoaderContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		margin: '20px 0',
		position: 'relative',
	},
	circularLoader: {
		color: '#bfd730', // Same green as "Open Door" button
	},
	loaderText: {
		position: 'absolute',
		fontSize: '12px',
		color: '#333',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
	icon: {
		fontSize: '24px',
		color: '#ccc',
		cursor: 'pointer',
		'&:hover': {
			color: '#bedc13',
		},
	},
}));

function ProcessOrder({ history, match, location }: any) {
	// const { orderShortId } = match.params;
	const styles = useStyles();
	const [
		orders,
		,
		,
		,
		fetchOrderInvoice,
		,
		,
		cancelPendingOrder,
		poolActiveOrder,
		cancelPoolingActiveOrder,
		cancelVirtualOrder,
	] = useOrder();
	const { selectedOrder, cancellingPendingOrder = false, fetchedOrderInvoice = false, error, machineMessages = [] } = orders;
	const [logEvent] = useFirebase();
	const [, submitRating] = useRating();
	const [{ selectedPod } = {}] = usePod();

	const initiateFetch = useRef(false);
	const [qrCodeViewer, toggleQrCodeViewer] = useState<boolean>(false);
	const [ratingDlg, openRatingDlg] = useState<boolean>(false);
	const [isSocketUsed, setIsSocketUsed] = useState<boolean>(true);

	const noFetch = useMemo(() => {
		const { params: { orderId = '' } = {} } = match;
		return (
			selectedOrder &&
			selectedOrder.order_id === orderId &&
			(selectedOrder.status === COMPLETED_ORDER ||
				selectedOrder.status === CANCELLED_ORDER ||
				selectedOrder.status === FAILED_ORDER ||
				((selectedOrder.type_of_order === MACHINE_ORDER || selectedOrder.type_of_order === KIOSK_ORDER) &&
					selectedOrder.status === PARTIAL_ORDER))
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const parsedOrder = useMemo(() => {
		let parsedOrder = {};
		if (selectedOrder) {
			parsedOrder = { ...selectedOrder };
			if (selectedOrder.type_of_order === MACHINE_ORDER || selectedOrder.type_of_order === KIOSK_ORDER) {
				parsedOrder.order_items = JSON.parse(selectedOrder.proposedSkuJson);
				if (selectedOrder.status !== FAILED_ORDER && selectedOrder.sku_json && selectedOrder.sku_json !== '0-0') {
					parsedOrder.order_items = JSON.parse(selectedOrder.sku_json);
				}
			}
			parsedOrder.url=config.PHP_API_URL+'/tm/process-order/status/'+parsedOrder.order_id+'?__md=1';
		}

		if (parsedOrder && parsedOrder.order_items && 'skus' in parsedOrder.order_items) {
			parsedOrder.order_items = parsedOrder.order_items['skus'];
		}

		if (Array.isArray(parsedOrder.order_items) && parsedOrder.order_items.length > 0) {
			parsedOrder.order_items.sort(({ door_id: door1, tray_id: tray1 }, { door_id: door2, tray_id: tray2 }) => {
				if (!door1) {
					return 0;
				}

				const doorDiff = +door1 - +door2;
				return doorDiff === 0 ? +tray1 - +tray2 : doorDiff;
			});
		}

		return parsedOrder;
	}, [selectedOrder]);

	const [drawer, setDrawer] = useState(false);
	const [realtimeStatus, setRealtimeStatus] = useState('');
	const [statusHistory, setStatusHistory] = useState([]);
	const [hasTimedOut, setHasTimedOut] = useState(false);
	const [isDoorOpenedDelay, setIsDoorOpenedDelay] = useState(false);
	const doorOpenedTimeoutRef = useRef(null);

	// Get order ID from route params
	const { params: { orderId = '' } = {} } = match;

	// Determine if this is a vending order from pod configuration
	const bVendingOrder = useMemo(() => {
		if (selectedPod && selectedPod.vm_id === parsedOrder.vm_id) {
			const { webapp_config = '' } = selectedPod;
			if (webapp_config) {
				try {
					const webappConfig = JSON.parse(webapp_config);
					const { vending_order = 0 } = webappConfig;
					return !!vending_order;
				} catch (error) {
					console.warn('Failed to parse webapp_config:', error);
				}
			}
		}
		return false;
	}, [selectedPod, parsedOrder.vm_id]);

	// Real-time communication for order tracking and machine messages
	const { connected: socketConnected, error: socketError, lastUpdate, reconnect } = useRealtimeConnection({
		orderId: orderId,
		machineImei: parsedOrder.vm_imei_id,
		bVendingOrder: bVendingOrder,
		autoConnect: true,
		subscribeToOrder: true,
		subscribeToMachine: true,
		autoSendStartOrder: false
	});

	const handleCancelOrder = useCallback(() => {
		const { order_id, type_of_order, pre_auth_amount } = selectedOrder;
		const date = new Date(selectedOrder.last_modified_at || selectedOrder.created_at);
		const time = Math.floor((Date.now() - date.getTime()) / 1000);
		if (type_of_order === VIRTUAL_ORDER) {
			cancelVirtualOrder(order_id);
			logEvent('tm_cancel_vs_order', { time_elapsed: time, amount: pre_auth_amount });
		} else {
			cancelPendingOrder(order_id, false);
			logEvent('cancel_active_order', { time_elapsed: time, amount: pre_auth_amount });
		}
	}, [cancelPendingOrder, cancelVirtualOrder, logEvent, selectedOrder]);

	// const handleSubmitRating = (ratingData) => {
	// 	submitRating(ratingData);
	// 	openRatingDlg(false);
	// 	logEvent('submit_rating', {
	// 		rating: ratingData.rating,
	// 	});
	// };

	const handleSubmitRating = useCallback(
		(ratingData) => {
			openRatingDlg(false);
			logEvent('submit_rating', {
				rating: ratingData.rating,
			});
			const { vm_imei_id: location, order_id, user_id } = selectedOrder;
			submitRating({
				...ratingData,
				type: 'overall_rating',
				user_id,
				location,
				order_id,
			});
		},
		[logEvent, selectedOrder, submitRating]
	);

	const openRatingDialog = useCallback(() => {
		logEvent('open_rating');
		openRatingDlg(true);
	}, [logEvent]);

	const generateAccessQR = useCallback(() => {
		toggleQrCodeViewer(true);
	}, []);

	// Get the latest machine message for current machine
	const latestMachineMessage = useMemo(() => {
		if (!parsedOrder.vm_imei_id) return null;

		const filteredMessages = machineMessages
			.filter(msg =>
				msg.imei === parsedOrder.vm_imei_id &&
				msg.display.showOnUI
			)
			.sort((a, b) => {
				// Sort by timestamp only (newest first) - ignore priority
				return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
			});

		// Return only the latest (first after sorting)
		return filteredMessages.length > 0 ? filteredMessages[0] : null;
	}, [machineMessages, parsedOrder.vm_imei_id]);

	useEffect(() => {
		// Skip polling if WebSocket is connected and we have recent real-time data
		const shouldSkipPolling = socketConnected && orders.lastRealtimeUpdate;

		if (shouldSkipPolling) {
			initiateFetch.current = true;
			return;
		}

		if (orderId) {
			initiateFetch.current = true;
			// Only fetch if we don't already have the selected order data
			// This preserves data set from PaymentSuccess page via handleSelectOrder
			if (!selectedOrder || selectedOrder.order_id !== orderId) {
				fetchOrderInvoice(orderId, 'ORDER_ID');
			}

			// Start polling after 2 seconds (fallback when WebSocket fails)
			setTimeout(() => {
				poolActiveOrder(orderId);
			}, 2000);
		}

		return () => {
			if (!shouldSkipPolling) {
				cancelPoolingActiveOrder();
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [socketConnected, orders.lastRealtimeUpdate, orderId]);

	// Fallback mechanism: Start polling if WebSocket disconnects
	useEffect(() => {
		if (!socketConnected && orderId && orders.lastRealtimeUpdate) {
			console.log('⚠️ WebSocket disconnected, starting fallback polling...');

			// Wait a bit for reconnection attempt, then start polling
			const fallbackTimer = setTimeout(() => {
				if (!socketConnected) {
					poolActiveOrder(orderId);
				}
			}, 3000);

			return () => {
				clearTimeout(fallbackTimer);
			};
		}
	}, [socketConnected, orderId, orders.lastRealtimeUpdate, poolActiveOrder]);


	// Handle real-time status updates from Redux
	useEffect(() => {
		if (orders.realtimeStatuses.length > 0 && orderId) {
			const latestStatus = orders.realtimeStatuses.find(status => status.orderId === orderId);
			if (latestStatus) {
				// If we're in doorOpened delay period, ignore new messages
				if (isDoorOpenedDelay) {
					return; // Block all new message processing
				}

				// Process the status normally - display it immediately
				setRealtimeStatus(latestStatus.status);
				setHasTimedOut(false); // Reset timeout when we get real-time status
				setStatusHistory(prev => [{
					timestamp: latestStatus.timestamp,
					status: latestStatus.status,
					metadata: latestStatus.metadata
				}, ...prev.slice(0, 9)]); // Keep last 10 status updates

				// If this is doorOpened, start the 3500ms delay period so the user **clearly** sees the message...
				if (latestStatus.status === 'doorOpened') {
					setIsDoorOpenedDelay(true);

					// Clear any existing timeout
					if (doorOpenedTimeoutRef.current) {
						clearTimeout(doorOpenedTimeoutRef.current);
					}

					// Set delay to block new messages for 3500ms
					doorOpenedTimeoutRef.current = setTimeout(() => {
						setIsDoorOpenedDelay(false);
					}, 3500);
				}
			}
		}
	}, [orders.realtimeStatuses, orderId, isDoorOpenedDelay]);

	// Cleanup doorOpened timeout on unmount
	useEffect(() => {
		return () => {
			if (doorOpenedTimeoutRef.current) {
				clearTimeout(doorOpenedTimeoutRef.current);
			}
		};
	}, []);

	// Check IMEI and switch to iframe UI for specific machines
	useEffect(() => {
		if (parsedOrder.vm_imei_id) {
			/* Old logic for Spiral machines...
			 */
			const shouldUseIframe = IFRAME_ONLY_MACHINES.includes(parsedOrder.vm_imei_id);
			setIsSocketUsed(!shouldUseIframe);
			/* New logic for deploying in phases...
			const shouldUseSocket = SOCKET_ONLY_MACHINES.includes(parsedOrder.vm_imei_id);
			setIsSocketUsed(shouldUseSocket);
			*/
		}
	}, [parsedOrder.vm_imei_id]);

	// Get status display content based on machine messages or server_status
	const getStatusDisplayContent = () => {
		// Compare timestamps and show the latest message (machine or order)
		const latestOrderTimestamp = statusHistory[0]?.timestamp ? new Date(statusHistory[0].timestamp).getTime() : 0;
		const latestMachineTimestamp = latestMachineMessage ? new Date(latestMachineMessage.timestamp).getTime() : 0;

		// If machine message is latest and has valid content, show it
		if (latestMachineMessage &&
			latestMachineMessage.display.header &&
			latestMachineMessage.display.header.trim() &&
			latestMachineTimestamp > latestOrderTimestamp) {

			// Use soothing blue color for system_status messages
			const headerColor = latestMachineMessage.messageType === 'system_status' ? '#4A90E2' : '#333';

			return {
				showLoader: false,
				header: latestMachineMessage.display.header,
				subHeader: latestMachineMessage.display.subHeader,
				headerStyle: {
					fontSize: '18px',
					fontWeight: 'bold',
					color: headerColor, // Blue for system_status, dark for others
					textAlign: 'center'
				},
				subHeaderStyle: {
					fontSize: '14px',
					color: '#666',
					textAlign: 'center',
					marginTop: '8px'
				}
			};
		}

		// If no real-time status yet, show loader (initial state)
		if (!realtimeStatus) {
			return {
				showLoader: true,
				header: null,
				subHeader: null
			};
		}

		const serverStatus = realtimeStatus;
		const metadata = statusHistory[0]?.metadata;


		// Case 1: init-process or order-started
		/* Suj: Even here show the "please wait..." loader
		if (serverStatus === 'init-process' || serverStatus === 'order-started') {
			return {
				showLoader: false,
				header: 'Wait for the blinking light !!!',
				subHeader: 'then open the door',
				headerStyle: { fontSize: '18px', fontWeight: 'bold', color: '#e67e22', textAlign: 'center' },
				subHeaderStyle: { fontSize: '16px', color: '#2c3e50', textAlign: 'center', fontWeight: '500' }
			};
		}
		*/

		// Case: Cancelled - order failed, show error from Pi
		if (serverStatus === 'Cancelled') {
			try {
				let errorData = null;
				if (metadata && metadata.server_response) {
					errorData = JSON.parse(metadata.server_response);
				}
				const header = errorData?.SectionStatus?.Header || 'Order Failed';
				const subHeader = errorData?.SectionStatus?.SubHeader || 'Please try again';
				return {
					showLoader: false,
					header: header,
					subHeader: subHeader,
					headerStyle: { fontSize: '18px', fontWeight: 'bold', color: '#e74c3c', textAlign: 'center' },
					subHeaderStyle: { fontSize: '14px', color: '#666', textAlign: 'center' }
				};
			} catch (error) {
				console.error('Error parsing Cancelled server_response:', error);
			}
		}

		// Case 2: processOrder or OrderStatus - parse server_response
		if (serverStatus === 'doorOpened' || serverStatus === 'processOrder' || serverStatus === 'OrderStatus') {
			try {
				let serverResponse = null;

				if (metadata && metadata.server_response) {
					// server_response is a JSON string that needs to be parsed
					serverResponse = JSON.parse(metadata.server_response);
				}

				if (serverResponse) {
					const voiceNote = serverResponse.voiceNote || '';
					const subHeader = serverResponse.SectionStatus?.SubHeader || '';

					return {
						showLoader: false,
						header: voiceNote,
						subHeader: subHeader,
						headerStyle: { fontSize: '18px', fontWeight: 'bold', color: '#333' },
						subHeaderStyle: { fontSize: '14px', color: '#666' }
					};
				}
			} catch (error) {
				console.error('🔴 Error parsing server_response JSON string:', error);
			}
		}

		// Case 3: invoiceOrder
		if (serverStatus === 'invoiceOrder') {
			try {
				let orderData = null;

				if (metadata && metadata.server_response) {
					// server_response is a JSON string that needs to be parsed
					orderData = JSON.parse(metadata.server_response);
				}

				if (orderData) {
					const allSkus = orderData.skus || [];
					let skus = allSkus;
					let totalAmount = orderData.total_amount || 0;

					// For bVending orders, only count items with cstatus == "Completed"
					if (bVendingOrder) {
						const completedSkus = allSkus.filter(sku => sku.cstatus === 'Completed');
						skus = completedSkus;

						// Recalculate total amount for completed items only
						totalAmount = completedSkus.reduce((sum, sku) => {
							const itemAmount = sku.amount || sku.sku_total || 0;
							return sum + itemAmount;
						}, 0);
					}

					if (skus.length === 0) {
						// No items picked/vended or no completed items
						return {
							showLoader: false,
							header: 'Order Completed',
							subHeader: bVendingOrder ? 'No items were vended' : 'No items were picked',
							headerStyle: { fontSize: '18px', fontWeight: 'bold', color: '#4caf50' },
							subHeaderStyle: { fontSize: '14px', color: '#666' }
						};
					} else {
						// Items were picked/vended
						return {
							showLoader: false,
							header: 'Order Completed',
							subHeader: null,
							headerStyle: { fontSize: '18px', fontWeight: 'bold', color: '#4caf50' },
							customContent: { skus, totalAmount }
						};
					}
				}
			} catch (error) {
				console.error('🔴 Error parsing invoiceOrder JSON:', error);
			}

			// Fallback case
			return {
				showLoader: false,
				header: 'Order Completed',
				subHeader: 'No items were picked',
				headerStyle: { fontSize: '18px', fontWeight: 'bold', color: '#4caf50' },
				subHeaderStyle: { fontSize: '14px', color: '#666' }
			};
		}

		// Default case - show loader for unknown status
		return {
			showLoader: true,
			header: null,
			subHeader: null
		};
	};

	const statusContent = getStatusDisplayContent();

	// Function to get status icon based on current status
	const getStatusIcon = () => {
		let messageStatus = null;

		// Get latest message timestamps
		const machineMessageTime = latestMachineMessage ? new Date(latestMachineMessage.timestamp).getTime() : 0;
		const orderStatusTime = statusHistory.length > 0 ? new Date(statusHistory[0].timestamp || 0).getTime() : 0;

		// If both messages exist and are close in time (within 5 seconds), machine message has priority
		const timeDifferenceMs = Math.abs(machineMessageTime - orderStatusTime);
		const concurrentThreshold = 5000; // 5 seconds

		if (latestMachineMessage && latestMachineMessage.display.header &&
		    statusHistory.length > 0 && timeDifferenceMs <= concurrentThreshold) {
			// Concurrent messages: machine message has priority
			if (latestMachineMessage.messageType === "system_status") {
				messageStatus = latestMachineMessage.metadata?.status;
			}
		} else {
			// Use the latest message regardless of source
			if (machineMessageTime > orderStatusTime && latestMachineMessage && latestMachineMessage.display.header) {
				// Latest machine message
				if (latestMachineMessage.messageType === "system_status") {
					messageStatus = latestMachineMessage.metadata?.status;
				}
			} else if (statusHistory.length > 0) {
				// Latest order status
				messageStatus = statusHistory[0].status;
			}
		}

		// Decide icon based on content
		switch (messageStatus) {
			case 'system_updating':
				return '/images/system-updating-icon.svg'; // NEW ICON
			case 'system_update_complete':
				return '/images/order-success-icon.svg'; // Reuse success icon
			case 'doorOpened':
				return '/images/door-pull-icon.svg';
			case 'invoiceOrder':
				return '/images/order-success-icon.svg';
			case 'processOrder':
			case 'OrderStatus':
				return '/images/order-processing-icon.svg';
			default:
				return null;
		}
	};

	// Calculate total items for OrderHeader
	const totalItems = useMemo(() => {
		if (!parsedOrder.order_items || !Array.isArray(parsedOrder.order_items)) {
			return 0;
		}
		return parsedOrder.order_items.reduce((total, item) => total + (item.qty || 1), 0);
	}, [parsedOrder.order_items]);

	// Memoized values for OrderHeader to prevent continuous re-rendering
	const emptyCancelledOrderIds = useMemo(() => new Set(), []);
	const emptyToggleFunction = useCallback(() => {}, []);
	const isOrderActiveFunction = useCallback((order) => {
		return (order.status === ACTIVE_ORDER || order.status === RECEIVED_ORDER);
	}, []);

	return (
		<>
			<section className={styles.pageContainer}>
				<section className={styles.header}>
					<section style={{ display: 'flex', width: '100%' }}>
						{history.length > 1 && (
							<IconButton aria-label='open side nav' classes={{ root: styles.backBtn }} onClick={() => setDrawer(true)}>
								<Icon className={styles.backIcon}>menu</Icon>
							</IconButton>
						)}
						<div
							style={{
								lineHeight: '28px',
								color: 'white',
								padding: '0 10px',
								fontSize: '16px',
							}}
						>
							Process Order
						</div>
					</section>
				</section>
				<section className={styles.mainContainer} >
					<center>

						<OrderHeader
							orderDetails={parsedOrder}
							index={0}
							totalOrders={1}
							totalItems={totalItems}
							isExpanded={true}
							onToggleExpand={emptyToggleFunction}
							cancelledOrderIds={emptyCancelledOrderIds}
							showToggleButton={false}
							showStatus={false}
							isOrderActive={isOrderActiveFunction}
						/>

						{/* Connection Status Indicator */}
						{ false && isSocketUsed && (
						<div style={{ marginTop: '12px', marginBottom: '10px', fontSize: '12px' }}>
							<span style={{ color: socketConnected ? '#43a047' : '#ff6b6b' }}>
								{socketConnected ? '🟢 Machine online' : '🔴 Checking machine status'}
							</span>
							{socketError && false && (
								<div style={{ color: '#ff6b6b', fontSize: '10px' }}>
									Error: {socketError}
								</div>
							)}
						</div>
						)}


						{/* Unified Card Container for both loader and status messages */}
						{ isSocketUsed && (
						<div style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							minHeight: '200px', // Ensure adequate space for vertical centering
							margin: '20px 20px', // 10px left and right margins
							padding: '0'
						}}>
							<div style={{
								padding: '20px 10px',
								backgroundColor: '#f8f9fa',
								borderRadius: '8px',
								border: '1px solid #e9ecef',
								textAlign: 'center',
								width: '100%',
								maxWidth: '500px' // Increased maximum width
							}}>
								{statusContent.showLoader ? (
									// Show loader inside the card
									<>
										<LoadingProgressIndicator
											realtimeStatus={realtimeStatus}
											styles={styles}
											onTimeout={() => setHasTimedOut(true)}
										/>
										{/* Show retry and support section only when loader has timed out */}
										{hasTimedOut && (
											<Button
												variant='contained'
												onClick={() => history.push(`/orders/${orderId}/invoice`)}
												style={{
													background: '#bfd730',
													font: 'bold',
													textDecoration: 'none',
													lineHeight: '42px',
													marginBottom: '20px',
													boxShadow: '0px 1px 5px 0px',
													width: '250px',
													minWidth: '250px',
													color: 'black',
													borderRadius: '5px',
													cursor: 'pointer'
												}}
											>
												Retry Order
											</Button>
										)}
										{hasTimedOut && (
											<OrderHelpSection
												orders={[parsedOrder]}
												onSupportClick={(orderId) => {
													history.push(`/orders/${orderId}/help`);
												}}
												onRatingClick={openRatingDialog}
												logEvent={logEvent}
											/>
										)}
									</>
								) : (
									// Show custom status messages inside the card
									statusContent.header && (
										<>
											{/* Status Icon */}
											{getStatusIcon() && (
												<div style={{
													marginBottom: '20px',
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center'
												}}>
													<img
														src={getStatusIcon()}
														alt="Status"
														style={{
															width: '64px',
															height: '64px',
															objectFit: 'contain',
															maxWidth: '100%',
															maxHeight: '100%'
														}}
													/>
												</div>
											)}

											{/* Header */}
											<div style={{
												...statusContent.headerStyle,
												marginBottom: '15px', // Gap between Header and SubHeader
												lineHeight: '1.3'
											}}>
												{statusContent.header}
											</div>

											{/* SubHeader or Custom Content */}
											{statusContent.customContent ? (
												// Show picked items and total bill
												<div style={{ marginTop: '20px' }}>
													{/* Total Bill Value Card */}
													<div style={{
														backgroundColor: '#f8f9fa',
														border: '1px solid #e9ecef',
														borderRadius: '8px',
														padding: '5px',
														marginBottom: '15px',
														textAlign: 'center'
													}}>
														<div style={{
															fontSize: '16px',
															fontWeight: 'bold',
															color: '#2c3e50',
															marginBottom: '5px'
														}}>
															Total Bill Value
														</div>
														<div style={{
															fontSize: '20px',
															fontWeight: 'bold',
															color: '#e67e22'
														}}>
															₹{statusContent.customContent.totalAmount}
														</div>
													</div>

													{/* Picked Items */}
													<div style={{ textAlign: 'left' }}>
														<div style={{
															fontSize: '14px',
															fontWeight: 'bold',
															color: '#2c3e50',
															marginBottom: '10px',
															textAlign: 'center'
														}}>
															{bVendingOrder ? "Items Vended" : "Items Picked"}
														</div>
														{statusContent.customContent.skus.map((item, index) => (
															<div key={index} style={{
																display: 'flex',
																alignItems: 'stretch',
																backgroundColor: 'white',
																border: '1px solid #e9ecef',
																borderRadius: '8px',
																padding: '10px',
																marginBottom: '8px',
																boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
																minHeight: '60px'
															}}>
																{/* Product Image */}
																<img
																	src={item.image_url}
																	alt={item.name}
																	style={{
																		width: '40px',
																		height: '40px',
																		objectFit: 'cover',
																		borderRadius: '4px',
																		marginRight: '12px',
																		alignSelf: 'flex-start'
																	}}
																	onError={(e) => {
																		e.target.style.display = 'none';
																	}}
																/>

																{/* Product Details */}
																<div style={{ flex: 1, fontSize: '12px', display: 'flex', flexDirection: 'column' }}>
																	<div style={{
																		fontWeight: 'bold',
																		color: '#2c3e50',
																		marginBottom: '4px',
																		lineHeight: '1.2'
																	}}>
																		{item.name}
																	</div>
																	<div style={{ color: '#7f8c8d', fontSize: '11px' }}>
																		{item.door_id && item.tray_id ? `DOOR ${item.door_id}, TRAY #${item.tray_id}` :
																		 item.door_id ? `DOOR ${item.door_id}, TRAY -` :
																		 item.tray_id ? `DOOR -, TRAY #${item.tray_id}` :
																		 'DOOR -, TRAY -'}
																	</div>
																</div>

																{/* Vertical Separator */}
																<div style={{
																	width: '1px',
																	backgroundColor: '#ccd1d7',
																	margin: '0 12px',
																	alignSelf: 'stretch'
																}}></div>

																{/* Item Amount Details */}
																<div style={{
																	textAlign: 'right',
																	fontSize: '12px',
																	display: 'flex',
																	flexDirection: 'column',
																	justifyContent: 'center'
																}}>
																	<div style={{
																		color: '#000',
																		marginBottom: '2px'
																	}}>
																		₹{item.unit_price} x {item.qty} {item.qty > 1 ? 'units' : 'unit'}
																	</div>
																	<div style={{
																		fontWeight: 'bold',
																		color: '#2c3e50',
																		fontSize: '14px'
																	}}>
																		₹{item.sku_total}
																	</div>
																</div>
															</div>
														))}
													</div>
												</div>
											) : (
												// Show regular subHeader
												statusContent.subHeader && (
													<div style={{
														...statusContent.subHeaderStyle,
														lineHeight: '1.4'
													}}>
														{statusContent.subHeader}
													</div>
												)
											)}
										</>
									)
								)}
							</div>
						</div>
						)}

						{ !isSocketUsed && (
						<div style={{
							overflow:'auto scroll !important',
							WebkitOverflowScrolling:'touch !important',
							width:'100%',

						}}>
					<iframe className={styles.invoiceContainer}  src={parsedOrder.url} sandbox='allow-scripts allow-popups'></iframe>
						</div>
						)}
					</center>
					<BottomNav />
					<TMDrawer open={drawer} toggleDrawer={setDrawer} />
				</section>
			</section>
			<RatingDlg open={ratingDlg} closeDialog={() => openRatingDlg(false)} submitRating={handleSubmitRating} />

		</>
	);
}

export default ProcessOrder;
